<template>
  <v-container>
    <v-slide-x-transition>
      <v-data-table
        :headers="prop_headers"
        :items="prop_items"
        class="elevation-1"
        :loading="propsLoading"
        loading-text="Загружаю данные"
        item-key="PROP_ID"
        show-select
        single-select
        :search="propSearch"
        :footer-props="{
          itemsPerPageText: 'На страницу',
          itemsPerPageAllText: 'Все',
          pageText: 'из'
        }"
        dense
        :value="value"
        @input="setValue"
      >
        <template v-slot:top>
          <v-toolbar color="primary" dark dense>
            <v-toolbar-title>Свойства</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="propSearch"
              append-icon="mdi-magnify"
              label="Искать"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:[`item.PROP_MIN`]="{ item }">
          {{ numLocaleDecorator(item.PROP_MIN) }}
        </template>
        <template v-slot:[`item.PROP_MAX`]="{ item }">
          {{ numLocaleDecorator(item.PROP_MAX) }}
        </template>
        <template v-slot:[`item.PROP_KOEFF`]="{ item }">
          {{ numLocaleDecorator(item.PROP_KOEFF) }}
        </template>
        <template v-slot:no-data>
          Нет данных
        </template>
      </v-data-table>
    </v-slide-x-transition>
  </v-container>
</template>

<script>
import { RCPT_GET_RCPT_PROPERTIES } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'
import { numDecorator } from '@/components/modules/projects/mixins/numDecorator'

export default {
  name: 'projectPropertiesTable',
  props: ['value', 'project'],
  mixins: [numDecorator],
  components: {
  },
  data () {
    return {
      prop_headers: [
        { text: 'Свойство', value: 'PROP_NAME' },
        { text: 'Мин', align: 'end', cellClass: ' text-end', value: 'PROP_MIN' },
        { text: 'Макс', align: 'end', cellClass: ' text-end', value: 'PROP_MAX' },
        { text: 'Коэффициенты', align: 'end', cellClass: ' text-end', value: 'PROP_KOEFF' },
        { text: 'Ед.изм.', align: 'end', value: 'MU_TXT_NAME' }
      ],
      propsLoading: false,
      propSearch: '',
      selectedProp: [],
      prop_items: []
    }
  },
  watch: {
    project () {
      this.getPropList()
    },
    value (val) {
      console.log('projectPropertiesTable value changed to ', val)
      if (!val || !val.length || !val[0].PROP_ID) return
      const curr = this.prop_items.findIndex(itm => itm.PROP_ID === val[0].PROP_ID)
      if (curr >= 0) {
        if (val[0].action === 'delete') {
          this.prop_items.splice(curr, 1)
          return
        }
        this.prop_items.splice(curr, 1, val[0])
      } else {
        this.prop_items.push(val[0])
      }
    }
  },
  computed: {
  },
  mounted: function () {
    if (this.prop_items.length === 0) {
      this.getPropList()
    }
  },
  methods: {
    setValue (val) {
      console.log('projectPropertiesTable setting value to ', val)
      this.$emit('input', val)
    },
    getPropList () {
      this.propLoading = true
      this.$store.dispatch(RCPT_GET_RCPT_PROPERTIES, { ULF_ID: this.project.ULF_ID || null, ULF_UUID: this.project.ULF_UUID || null })
        .then((res) => {
          this.prop_items.splice(0, this.prop_items.length, ...res)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка свойств: \n ${err}` })
        })
        .finally(() => {
          this.propLoading = false
        })
    }
  }
}
</script>
